<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" style="border-radius: 5px" @click="goAdd" v-if="isHavePermission('taxInfo:addTaxpayer')">新增纳税人</Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px;border-radius: 5px">刷新</Button>
      <div class="search-filter">
        <Poptip placement="top-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="纳税人名称" field="userName" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.userName" placeholder="输入纳税人名称"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="证件号码" field="idcardNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.idcardNum" placeholder="输入证件号码"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="手机号" field="regisiterNum" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.regisiterNum" placeholder="输入手机号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="税务机关" field="ordersState" span="12">
                <template v-slot>
                  <Select v-model="taxIds" multiple placeholder="选择税务机关" :max-tag-count="1"
                          :max-tag-placeholder="maxTagPlaceholder">
                    <Option v-for="(item,index) in taxList" :value="item.id" :key="index">{{ item.taxComp }}</Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button
                      type="primary"
                      icon="ios-search"
                      @click="getSearchListKey"
                      style="border-radius: 5px"
                  >搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
                  >重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="listData"
          :filter-config="{ remote: true }"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="90"></vxe-table-column>
        <vxe-table-column title="操作" width="50" v-if="isHavePermission('taxInfo:updateTaxpayer')">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="cursor: pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo"
                          @click="openEditView(row.id)">编辑
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="userName" title="纳税人名称" min-width="130">
          <template slot-scope="{ row }">
            <a @click="openDetail(row.id)">{{ row.userName }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idcardNum" title="证件号码" min-width="150" align="center"></vxe-table-column>
        <vxe-table-column field="regisiterNum" title="手机号" min-width="150" align="center"></vxe-table-column>
        <vxe-table-column field="taxNum" title="纳税人识别号" min-width="105" align="center"></vxe-table-column>
        <vxe-table-column field="taxComp" title="税务机关" min-width="150" align="center"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="taxVisible" :title="taxTitle" width="800" height="500" @close="close"
               resize position="center" destroy-on-close>
      <add-taxpayer ref="addTaxpayer" :taxList="taxList" @close="closeAdd" @update="setUpdateTitle"></add-taxpayer>
    </vxe-modal>
  </div>
</template>
<script>


import moment from "moment";
import {isEmpty} from "@/utils/util";
import $api from "@/apiProvider";
import addTaxpayer from "@/components/taxInfo/addTaxpayer";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {addTaxpayer},
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      searchLoading: false,
      listData: false,
      searchVisible: false,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      searchFormData: {
        userName: null,
        idcardNum: null,
        regisiterNum: null,
      },
      taxIds: [],
      taxList: [],
      taxOption: [],
      taxVisible: false,
      taxTitle: '',
      open: false
    }
  },
  mounted() {
    this.getListData();
    this.getTaxList();
  },
  methods: {
    openEditView(id){
      this.taxTitle = '编辑纳税人'
      this.taxVisible = true;
      this.$nextTick(() => {
        this.$refs.addTaxpayer.setEdit(id);
      })
    },
    goAdd() {
      this.taxVisible = true;
      this.taxTitle = '新增纳税人';
      this.$nextTick(() => {
        this.$refs.addTaxpayer.init();
      })
    },
    async getTaxList() {
      let res = await $api.tax.post('getTaxList', {});
      if (res.status === 1) {
        this.taxList = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.taxVisible = false;
    },
    closeAdd() {
      this.taxVisible = false;
      this.getListData(this.paramsObj);
    },
    openDetail(id) {
      this.taxTitle = '纳税人详情'
      this.taxVisible = true;
      this.$nextTick(() => {
        this.$refs.addTaxpayer.setDetail(id);
      })
    },
    setUpdateTitle() {
      this.taxTitle = '编辑纳税人'
    },
    async getListData(obj) {
      let params = obj ? obj : {
        page: this.page.currentPage,
        rows: this.page.pageSize,
      };
      this.loading = true;
      let res = await $api.tax.post("getClientTaxInfoList", params);
      this.loading = false;
      if (res.status === 1) {
        let data = res.data;
        this.page.totalResult = data.total;
        this.listData = data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    refresh() {
      this.getSearchListKey();
    },
    reset() {
      this.searchFormData = {};
      this.taxIds = [];
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        cate: columnType,
        name: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};

      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && obj[key] !== undefined) {
          paramsObj[key] = obj[key];
        }
      });

      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      this.page.currentPage = 1;
      this.page.pageSize = 10;

      if (this.taxIds.length > 0) {
        paramsObj.taxIds = this.taxIds;
      }

      this.paramsObj = paramsObj;
      this.getListData(paramsObj);
      this.searchVisible = false;
    },
    handlePageChange(e) {
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.getListData(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getListData();
      }
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      // console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
  }
}
</script>
<style>

</style>

